/* eslint-disable */
import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import 'contents/assets/scss/page/teacher.scss';
import Tab from '../../../component/Inc/Tab';
function TeacherCampaign() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '진행중 캠페인', value: 1},
    {title: '진행 완료 캠페인', value: 2}
  ];
  return (
    <main className="com_container">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_10">실적관리 캠페인</h2>
          <div className="com_btn_wrap">
            <Link to="/Teacher/Campaign/Create" className="com_btn orange s btn_plus">
              캠페인 만들기
            </Link>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              <section className="com_board_search end">
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="70" />
                <col width="150" />
                <col width="auto" />
                <col width="auto" />
                <col width="150" />
                <col width="150" />
                <col width="150" />
                <col width="150" />
              </colgroup>
              <thead>
                <tr>
                  <th>No</th>
                  <th>등록일</th>
                  <th>캠페인 명</th>
                  <th>캠페인 기간</th>
                  <th>발표일</th>
                  <th>시상계획</th>
                  <th>비고</th>
                  <th>수정</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>2023, 05, 23</td>
                  <td>
                    <Link to="/Teacher/Campaign/Detail" className="btn_link">
                      2분기 실적관리 캠페인을 시작합니다.
                    </Link>
                  </td>
                  <td>2023, 05, 10 ~ 2023, 05, 12</td>
                  <td>2023,05, 10</td>
                  <td>2023,05, 10</td>
                  <td>종료</td>
                  <td>
                    <button className="btn_link blue">수정</button>
                  </td>
                </tr>
                {[2, 3, 4, 5].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>2023, 05, 23</td>
                      <td>
                        <Link to="/Teacher/Campaign/Detail" className="btn_link">
                          2분기 실적관리 캠페인을 시작합니다.
                        </Link>
                      </td>
                      <td>2024, 12, 10 ~ 2024, 12, 12</td>
                      <td>2024,12, 10</td>
                      <td>2024,12, 10</td>
                      <td className="com_blue_txt">진행중</td>
                      <td>
                        <button className="btn_link blue">수정</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </section>
        </section>
      </div>
    </main>
  );
}

export default TeacherCampaign;
